<li ngbDropdown #notificationDropdown="ngbDropdown" class="nav-item dropdown-notification mr-25">
  <a class="nav-link" ngbDropdownToggle id="navbarNotificationDropdown" ngbTooltip="Alertas"
    ><i class="ficon" data-feather="bell"></i
    ><span class="badge badge-pill badge-danger badge-up" *ngIf="getTotalNotificationCount() > 0">{{ getTotalNotificationCount() }}</span></a
  >
  <ul
    ngbDropdownMenu
    aria-labelledby="navbarNotificationDropdown"
    class="dropdown-menu dropdown-menu-media dropdown-menu-right"
  >
    <!-- Notifications header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Notificações</h4>
        <div class="badge badge-pill badge-light-primary">
          {{ getTotalNotificationCount() }} Novas
        </div>
      </div>
    </li>
    <!--/ Notifications header -->

    <!-- Notifications content -->
    <li class="scrollable-container media-list" [perfectScrollbar] style="max-height: 400px;">
      <!-- Regular Messages -->
      <a class="d-flex" 
         href="javascript:void(0)" 
         *ngFor="let message of paginatedMessages" 
         (click)="markAsRead(message)"
         [ngClass]="{
           'notification-read': isNotificationRead(message),
           'notification-unread': !isNotificationRead(message)
         }">
        <div class="media d-flex align-items-start">
          <div class="media-left">
            <div class="avatar" [style.opacity]="isNotificationRead(message) ? '0.5' : '1'">
              <img [src]="message.image" alt="avatar" width="32" height="32" />
            </div>
          </div>
          <div class="media-body" [style.opacity]="isNotificationRead(message) ? '0.6' : '1'">
            <p class="media-heading" [innerHTML]="message.heading"></p>
            <small class="notification-text">{{ message.text }}</small>
            <div class="d-flex justify-content-between align-items-center mt-1">
              <small class="text-muted">{{ formatNotificationDate(message.created_at) }}</small>
              <i *ngIf="isNotificationRead(message)" class="text-muted" data-feather="check" style="width: 14px; height: 14px;"></i>
            </div>
          </div>
        </div>
      </a>

      <!-- System Messages -->
      <a class="d-flex" 
         href="javascript:void(0)" 
         *ngFor="let systemMessage of paginatedSystemMessages" 
         (click)="markAsRead(systemMessage)"
         [ngClass]="{
           'notification-read': isNotificationRead(systemMessage),
           'notification-unread': !isNotificationRead(systemMessage)
         }">
        <div class="media d-flex align-items-start">
          <div class="media-left">
            <div
              class="avatar"
              [ngClass]="{
                'bg-light-danger': systemMessage.icon === 'x',
                'bg-light-success': systemMessage.icon === 'check',
                'bg-light-warning': systemMessage.icon === 'alert-triangle'
              }"
              [style.opacity]="isNotificationRead(systemMessage) ? '0.5' : '1'">
              <div class="avatar-content"><i class="avatar-icon" [data-feather]="systemMessage.icon"></i></div>
            </div>
          </div>
          <div class="media-body" [style.opacity]="isNotificationRead(systemMessage) ? '0.6' : '1'">
            <p class="media-heading" [innerHTML]="systemMessage.heading"></p>
            <small class="notification-text">{{ systemMessage.text }}</small>
            <div class="d-flex justify-content-between align-items-center mt-1">
              <small class="text-muted">{{ formatNotificationDate(systemMessage.created_at) }}</small>
              <i *ngIf="isNotificationRead(systemMessage)" class="text-muted" data-feather="check" style="width: 14px; height: 14px;"></i>
            </div>
          </div>
        </div>
      </a>

      <!-- Empty state -->
      <div *ngIf="totalNotifications === 0" class="text-center p-3">
        <i data-feather="bell-off" class="text-muted mb-2" style="width: 48px; height: 48px;"></i>
        <p class="text-muted mb-0">Nenhuma notificação</p>
      </div>
    </li>
    <!--/ Notifications content -->

    <!-- Pagination -->
    <li class="dropdown-menu-footer" *ngIf="getTotalPages() > 1">
      <div class="d-flex justify-content-between align-items-center px-3 py-2">
        <button 
          class="btn btn-sm btn-outline-secondary" 
          (click)="previousPage()" 
          [disabled]="currentPage === 1">
          <i data-feather="chevron-left" style="width: 14px; height: 14px;"></i>
        </button>
        
        <span class="text-muted small">
          Página {{ currentPage }} de {{ getTotalPages() }} 
          ({{ totalNotifications }} notificações)
        </span>
        
        <button 
          class="btn btn-sm btn-outline-secondary" 
          (click)="nextPage()" 
          [disabled]="currentPage === getTotalPages()">
          <i data-feather="chevron-right" style="width: 14px; height: 14px;"></i>
        </button>
      </div>
    </li>

    <!-- Notifications footer -->
    <li class="dropdown-menu-footer">
      <div class="d-flex">
        <a class="btn btn-outline-primary btn-sm flex-fill mr-1" 
           href="javascript:void(0)" 
           (click)="markAllAsRead()"
           *ngIf="getTotalNotificationCount() > 0">
          Ler todas
        </a>
        <span class="btn btn-light btn-sm flex-fill" 
              *ngIf="totalNotifications > 0">
          {{ totalNotifications }} total
        </span>
      </div>
    </li>
    <!--/ Notifications footer -->
  </ul>
</li>
